import { AccountInfo, AuthenticationResult, IPublicClientApplication } from '@azure/msal-browser'

import { loginRequest, msalService } from '../AuthConfig'

export async function getAuthToken(
  msalAccount?: AccountInfo,
  msalInstance?: IPublicClientApplication,
): Promise<string> {
  const account = msalAccount || msalService.account
  const instance = msalInstance || msalService.instance

  try {
    return await fetchTokenData(account, instance)
  } catch (error) {
    try {
      return await fetchTokenDataFromPopup(account, instance)
    } catch (interactiveError) {
      try {
        const loginResponse = await instance.loginPopup(loginRequest)
        return await fetchTokenData(loginResponse.account, instance)
      } catch (loginError) {
        console.error('Token acquisition failed:', loginError)
        throw new Error('Unable to acquire authentication token')
      }
    }
  }
}

async function fetchTokenData(account, instance): Promise<string> {
  const response: AuthenticationResult = await instance.acquireTokenSilent({
    ...loginRequest,
    account,
  })
  return response.accessToken
}

async function fetchTokenDataFromPopup(account, instance): Promise<string> {
  const response: AuthenticationResult = await instance.acquireTokenPopup({
    ...loginRequest,
    account,
  })
  return response.accessToken
}
